<template>
  <table class="w-100 table table-bordered evaluation-table">
    <tr>
      <th>{{ $t('scale') }}</th>
      <th>{{ t('skills')[0] }}</th>
      <th>{{ t('help')[0] }}</th>
      <th>{{ t('capability')[0] }}</th>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="4" /></td>
      <td v-html="t('skills')[1]"/>
      <td rowspan="2">{{ t('help')[1] }}</td>
      <td rowspan="2">{{ t('capability')[1] }}</td>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="3" /></td>
      <td v-html="t('skills')[2]"/>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="2" /></td>
      <td v-html="t('skills')[3]"/>
      <td>{{ t('help')[2] }}</td>
      <td>{{ t('capability')[2] }}</td>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="1" /></td>
      <td v-html="t('skills')[4]"/>
      <td>{{ t('help')[3] }}</td>
      <td rowspan="2">{{ t('capability')[3] }}</td>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="0" /></td>
      <td v-html="t('skills')[5]"/>
      <td>{{ t('help')[4] }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'SkillsTable',

  methods: {
    t (key) {
      return this.$i18n.t('components.evaluations.skills.' + key)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/evaluations/SkillsTable.vue